// extracted by mini-css-extract-plugin
module.exports = {"root":"Graph_root__GVsnd","header":"Graph_header__1bLq7","options":"Graph_options__8N_O-"};